export const PDF_HIGHLIGHT_COLORS_SETTING_KEY = 'pdfHighlightColors';

export const DEFAULT_PDF_HIGHLIGHT_COLORS = [
  '#ff595e',
  '#ff924c',
  '#ffca3a',
  '#8ac926',
  '#1982c4',
] as const;

const HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;

export function parsePdfHighlightColors(value: string | undefined): string[] {
  if (!value) {
    return [...DEFAULT_PDF_HIGHLIGHT_COLORS];
  }

  try {
    const parsed = JSON.parse(value) as unknown;
    if (!Array.isArray(parsed)) {
      return [...DEFAULT_PDF_HIGHLIGHT_COLORS];
    }

    const colors = parsed
      .map(color => typeof color === 'string' ? color.trim() : '')
      .filter(color => HEX_COLOR_PATTERN.test(color))
      .slice(0, DEFAULT_PDF_HIGHLIGHT_COLORS.length);
    return colors.length === DEFAULT_PDF_HIGHLIGHT_COLORS.length
      ? colors
      : [...DEFAULT_PDF_HIGHLIGHT_COLORS];
  } catch {
    return [...DEFAULT_PDF_HIGHLIGHT_COLORS];
  }
}

export function isPdfHighlightColor(value: string): boolean {
  return HEX_COLOR_PATTERN.test(value);
}
